'use client';

import { styled } from '../../styles';
import { IconButton } from '../IconButton';

export const SwipeableDrawerIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
  color: theme.palette.text3,
}));
